import { Suspense } from 'react';

// project import
import Loader from './Loader';

// ================|| LOADABLE - LAZY LOADING ||================ //

/*eslint-disable */
const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
